"use strict";
const pluginVersion = "12.2.1";
const defaultOptions = {
  showImage: true
};

export { defaultOptions, pluginVersion };
